import { trpcClient } from '@/lib/trpc';
import { useQuery } from '@tanstack/react-query';
import type { FKOption } from './useFKLookup';

const CACHE_TIME = 5 * 60 * 1000; // 5 min

export interface ConfigLookupOptions {
    valueField?: 'code' | 'name';
}

export function useConfigLookup(
    categoryCode: string,
    opts?: ConfigLookupOptions
): { options: FKOption[], isLoading: boolean } {
    const valueField = opts?.valueField || 'code';
    const { data, isLoading } = useQuery({
        queryKey: ['config-lookup', categoryCode, valueField],
        queryFn: async () => {
            try {
                const cat = await trpcClient.config.getCategoryWithItems.query({ code: categoryCode });
                if (cat && cat.items && cat.items.length > 0) {
                    return cat.items
                        .filter((i: any) => i.active !== false)
                        .map((i: any) => {
                            const val = valueField === 'name' ? i.name : (i.code || i.name);
                            return {
                                id: val,
                                label: i.name,
                                searchTags: `${i.name} ${i.code || ''}`,
                                subLabel: valueField === 'name' && i.code && i.code !== i.name ? i.code : undefined,
                            };
                        })
                        .sort((a: any, b: any) => a.label.localeCompare(b.label, 'vi'));
                }
                return [];
            } catch {
                return [];
            }
        },
        staleTime: CACHE_TIME,
        gcTime: CACHE_TIME * 2,
    });

    return {
        options: data ?? [],
        isLoading,
    };
}
